<script>
	import { goto } from '$app/navigation';
	import MetaTags from 'components/MetaTags/MetaTags.svelte';
</script>

<MetaTags title={'Error| CryptoMarketCap'} />

<div class="error-container">
	<h1 class="error-header">Oops!</h1>
	<h2 class="error-text">Something went wrong.</h2>
	<h3 class="error-text error-message">Please, go home page and try another coin.</h3>
	<button class="error-button" on:click={() => goto('/')}>Go home</button>
	<a class="error-contact-us" href="/contact us">Contact us for help.</a>
</div>

<style lang="scss">
	@import 'error';
</style>
